import { sellers } from '@/mocks/categories';

export default function SellerComparisonSection() {
  const getStars = (quality: number) => {
    const full = Math.floor(quality / 2);
    const half = quality % 2 >= 0.5;
    const stars = [];
    for (let i = 0; i < full; i++) {
      stars.push('ri-star-fill');
    }
    if (half) {
      stars.push('ri-star-half-line');
    }
    while (stars.length < 5) {
      stars.push('ri-star-line');
    }
    return stars;
  };

  return (
    <section id="sellers" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300/60 bg-accent-100/50 text-accent-900 text-xs font-medium mb-4">
            Trusted Sellers
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            Seller Comparison Table
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Compare the <strong>best allchinabuy spreadsheet</strong> sellers side by side — quality ratings, price ranges, shipping speeds, and our honest recommendations.
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/70 bg-background-100">
                  <th className="text-left px-5 py-4 font-label font-semibold text-foreground-700 text-xs uppercase tracking-wider whitespace-nowrap">Seller</th>
                  <th className="text-center px-5 py-4 font-label font-semibold text-foreground-700 text-xs uppercase tracking-wider whitespace-nowrap">Quality</th>
                  <th className="text-center px-5 py-4 font-label font-semibold text-foreground-700 text-xs uppercase tracking-wider whitespace-nowrap">Price</th>
                  <th className="text-center px-5 py-4 font-label font-semibold text-foreground-700 text-xs uppercase tracking-wider whitespace-nowrap">Shipping</th>
                  <th className="text-center px-5 py-4 font-label font-semibold text-foreground-700 text-xs uppercase tracking-wider whitespace-nowrap">Recommendation</th>
                </tr>
              </thead>
              <tbody>
                {sellers.map((seller, idx) => (
                  <tr key={seller.name} className={`border-b border-background-200/40 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                    <td className="px-5 py-4">
                      <span className="font-medium text-foreground-900">{seller.name}</span>
                    </td>
                    <td className="px-5 py-4 text-center">
                      <div className="flex items-center justify-center gap-0.5">
                        {getStars(seller.quality).map((star, i) => (
                          <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                            <i className={`${star} text-xs`}></i>
                          </span>
                        ))}
                        <span className="ml-1.5 text-xs font-medium text-foreground-600">{seller.quality}</span>
                      </div>
                    </td>
                    <td className="px-5 py-4 text-center">
                      <span className="font-semibold text-foreground-800">{seller.price}</span>
                    </td>
                    <td className="px-5 py-4 text-center">
                      <span className="text-foreground-600 text-xs">{seller.shipping}</span>
                    </td>
                    <td className="px-5 py-4 text-center">
                      <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${seller.badge}`}>
                        {seller.recommendation}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-center text-xs text-foreground-400 mt-4">
          * Ratings based on aggregated buyer reviews and independent research. Last updated June 2026.
        </p>
      </div>
    </section>
  );
}